/**
 * NeutralAccessPage  ·  Feb 2026
 *
 * Replaces the historical hardcoded fallback to `/suite/jackson/access`.
 * Shown when a client-side flow needs an access page but no specific
 * suite slug is known (e.g. someone hits `/portal/client` directly
 * without a session). Strictly neutral — does NOT unlock any client,
 * does NOT default to the Jackson family.
 *
 * Editorial dark canvas, same family as the per-suite access doors.
 */
import React from "react";

export default function NeutralAccessPage() {
  return (
    <div
      className="min-h-screen bg-[#0a0908] text-white flex flex-col"
      data-testid="neutral-access-page"
    >
      <header className="px-6 sm:px-10 lg:px-16 pt-8">
        <p className="font-mono text-[10px] uppercase tracking-[0.32em] text-[#c9a961]">
          VÉRAULT · Private Access
        </p>
      </header>

      <main className="flex-1 flex items-center justify-center px-6">
        <div className="max-w-md md:max-w-lg space-y-5 text-center sm:text-left">
          <p
            className="font-mono text-[10px] uppercase tracking-[0.24em] text-[#c9a961]"
            data-testid="neutral-access-eyebrow"
          >
            Private suite
          </p>
          <h1
            className="font-serif text-4xl sm:text-5xl leading-[1.05] tracking-tight"
            data-testid="neutral-access-headline"
          >
            Access required.
          </h1>
          <p
            className="font-accent italic text-[15px] sm:text-[16px] leading-relaxed text-white/80 max-w-prose"
            data-testid="neutral-access-copy"
          >
            Each VÉRAULT suite has its own private door. Please open the
            personal link your advisor sent you — it carries the access
            code you'll need.
          </p>
          <p className="font-accent italic text-[13.5px] text-white/55 max-w-prose">
            If you can't find the link, reply to your advisor's last note
            and they will resend it.
          </p>

          <div className="pt-4">
            <a
              href="/"
              className="inline-flex items-center gap-1.5 font-mono text-[10.5px] uppercase tracking-[0.22em] text-[#c9a961] hover:text-white transition-colors"
              data-testid="neutral-access-home"
            >
              ← Return to verault travels
            </a>
          </div>
        </div>
      </main>

      <footer className="px-6 sm:px-10 py-6">
        <p className="font-mono text-[9.5px] uppercase tracking-[0.28em] text-white/35 text-center">
          Private · Encrypted · Members only
        </p>
      </footer>
    </div>
  );
}
